import { PRODUCT_IDS } from "utils/constants";
import CreditMonitoringCard from "assets/card-credit-monitoring.webp";
import BoostCard from "assets/card-boost.webp";

export const PRODUCT_CARD_DEFAULT_CONFIG = {
  [PRODUCT_IDS.CREDIT_MONITORING]: {
    titleText: "Monitor your credit",
    subTitleText: "View your credit score and learn about factors that contribute to your score - for FREE!",
    buttonText: "Go to dashboard",
    imageSrc: CreditMonitoringCard,
    redirectUrl: "/credit-monitoring",
  },
  [PRODUCT_IDS.CREDIT_BOOST]: {
    titleText: "Boost your credit fast",
    subTitleText: "No credit checks (ever), AI-powered bill matching, personalized credit building.",
    buttonText: "Boost my score",
    imageSrc: BoostCard,
    redirectUrl: "/boost",
  },
};
